import React, { Component } from "react";
import api from "../../config/api";
import { connect } from "react-redux";
import {
  debitsSelectedComp,
  debitsSelectedIDsComp,
  valueAmountComp,
  openSnackComp,
  setOpenBankInfos,
  setAcquirersActives,
  setBankSelectedOnlinePayment,
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import ButtonTypeName from "../../components/ButtonTypeName";
import { checkDebitsExist } from "../../helper/checkDebitsExist";
import ButtonBack from "../../components/ButtonBack";
import { b64toBlob } from "../../helper/convertBase64toBlob";
import ModalMessage from "../../components/UserMessageHome";
import {
  convertBrazilianDateToISO,
  dateIsValid,
} from "../../helper/convertDate";
import PaymentDAM from "../PaymentDAM";
import { PaymentBank } from "../PaymentBank";
import AcquirerSelection from "../../components/AcquirerSelection";
import { getActiveAcquirers } from "../../helper/Acquirers";
import PaymentSimulation from "../../components/PaymentSimulation";
import { postSimulationCardPayment } from "../../helper/PaymentSimulation";
import { Typography } from "@material-ui/core";
import Messages from "../../helper/resources/Messages";
import LoadingDefault from "../../components/LoadingDefault";
import { getToken } from "../../config/enviroment";
import jwtDecode from "jwt-decode";

const styles = (theme) => ({
  containerPayMethods: { minHeight: "770px" },
  title: {
    position: "relative",
    marginTop: 30,
    textAlign: "center",
  },
  buttonBack: {
    position: "absolute",
    top: 5,
    left: 30,
  },
  container: {
    display: "flex",
    flexDirection: "column",
  },
  inputs: {
    display: "flex",
    width: "50%",
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  inputsItem: {
    width: "100%",
    marginBottom: "3px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "center",
    },
  },
  backButton: {},
  loadingDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  buttonBackDiv: {
    paddingTop: "8%",
    marginLeft: "15px",
    display: "flex",
    [theme.breakpoints.down("lg")]: {
      paddingTop: "10%",
    },
    [theme.breakpoints.down("md")]: {
      paddingTop: "12%",
    },
  },
  datePickerPayment: {
    display: "flex",
    // width: '70%',]
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
    },
  },
  sideMenu: {
    width: "20%",
    padding: "30px 20px 0 20px",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    overflow: "auto",
    height: "330px",
    position: "fixed",
  },
  buttonItem: {
    marginBottom: "12px",
    height: "95px",
    width: "100%",
    borderRadius: "5px",
  },
  contentSelected: {
    width: "73%",
    marginLeft: "25%",
  },
  svgIcon: {
    marginRight: "10px",
  },
});

export class PaymentMethods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msgSnackbar: "",
      titleMessage: "",
      openModal: false,
      errorCodeDAM: "",
      maxDateAllowed: "",
      dateLoaded: false,
      showPaymentOnline: false,
      showGenerateDam: false,
      showPaymentSimulation: false,
      showTextGuide: true,
      simulationData: {},
      acquirerSelected: {},
      selectedPortion: {},
      loading: false,
    };

    this.handleCreditCardPayment = this.handleCreditCardPayment.bind();
  }

  componentWillMount() {
    this.handleGetLastWorkDay();
    checkDebitsExist(this.props);
  }

  handleGetLastWorkDay = async () => {
    try {
      const lastWorkDayDateString = await api.get("Debitos/ultimo-dia-util");
      const date = convertBrazilianDateToISO(lastWorkDayDateString.data);
      const paymentDayDateString = await api.get("Debitos/dia-util");
      const paymentDate = convertBrazilianDateToISO(paymentDayDateString.data);

      if (date !== null && date !== undefined && date !== "") {
        var lastWork = date.split("-");

        this.setState({
          paymentDateValue: new Date(paymentDate),
          maxDateAllowed: new Date(
            lastWork[0],
            parseInt(lastWork[1]) - 1,
            lastWork[2]
          ),
          dateLoaded: true,
        });
      }
    } catch (error) {
      this.setState({
        msgSnackbar: "Ocorreu um erro ao carregar as datas para pagamento.",
        dateLoaded: true,
      });
      this.props.openSnackComp(true);
    }
  };

  checkDateRange = (isValidDate, DAMPaymentDate, todayDate, maxDateAllowed) => {
    return (
      !isValidDate ||
      DAMPaymentDate < todayDate ||
      DAMPaymentDate > maxDateAllowed
    );
  };

  checkDamDateNullOrEmpty = (DAMDate) => {
    return DAMDate === null || DAMDate === "";
  };

  getLocation = () => {
    return (
      this.props.location.state || {
        from: { pathname: "/pagamento-via-dam" },
      }
    );
  };

  handleGenerateDAM = async () => {
    this.setState({
      loading: true,
      openModal: false,
    });

    let Ids = this.props.debitsSelectedIDsValue;
    let DataPagamentoDAM = this.props.location.state.paymentDateValue;
    let isValidDate = dateIsValid(DataPagamentoDAM);
    let todayDate = new Date().setHours(0, 0, 0, 0);

    try {
      const paidDebits = this.props.debitsSelectedValue.some(
        (e) => e.CodigoSituacao === "Q"
      );

      if (paidDebits) {
        this.setState({
          msgSnackbar: Messages.DEBITOS_JA_FORAM_QUITADOS,
          loading: false,
        });

        this.props.openSnackComp(true);
      } else if (
        !isValidDate ||
        DataPagamentoDAM < todayDate ||
        DataPagamentoDAM > this.state.maxDateAllowed
      ) {
        this.setState({
          msgSnackbar: Messages.DATA_PAGAMENTO_HOJE_ULTIMO_DIA_MES,
          openModal: true,
        });
        this.props.openSnackComp(true);
      } else {
        let bodyRequest = {
          Ids: Ids,
          DataPagamento: DataPagamentoDAM,
        };

        const DAMResponse = await api.post(
          "Debitos/GerarBoletoDAM",
          bodyRequest
        );
        let pdf = "";

        if (DAMResponse.data.EhValida) {
          pdf = DAMResponse.data.Retorno;

          this.setState({
            loading: false,
            openModal: false,
          });

          var file = b64toBlob(pdf, "application/pdf");

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, "DAMPagueFacil.pdf");
          } else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "_blank");
          }
          this.setState({
            showGenerateDam: true,
            showPaymentOnline: false,
            showAcquirerSelection: false,
            showPaymentSimulation: false,
            showTextGuide: false,
          });
        } else {
          this.setState({
            openModal: true,
            loading: false,
            msgSnackbar: DAMResponse.data.Erros[0],
          });
        }

        if (DAMResponse.data === null || DAMResponse.data === "") {
          this.setState({
            loading: false,
            // openModal: true,
          });
        }
      }
    } catch (error) {
      this.setState({
        loading: false,
        // openModal: true,
      });
    }
  };

  newHandleOnlinePayment = () => {
    this.setState({
      showPaymentOnline: true,
      showGenerateDam: false,
      showAcquirerSelection: false,
      showPaymentSimulation: false,
      showTextGuide: false,
    });
  };

  handleAcquirerSelection = async () => {
    this.setState({ loading: true });

    await getActiveAcquirers().then((result) => {
      this.props.setAcquirersActives({
        acquirersActives: result,
        loading: false,
      });
    });

    this.setState({
      showAcquirerSelection: true,
      showGenerateDam: false,
      showPaymentOnline: false,
      showPaymentSimulation: false,
      showTextGuide: false,
      loading: false,
    });
  };

  handleCreditCardPayment = () => {
    const DataPagamentoDAM = this.props.paymentDateValue;
    const todayDate = new Date().setHours(0, 0, 0, 0);
    const isValidDate = dateIsValid(DataPagamentoDAM);
    if (this.props.debitsSelectedValue.length > 0) {
      //Verifica se algum débito listado para pagamento já foi quitado no SAT
      const paidDebits = this.props.debitsSelectedValue.some(
        (e) => e.CodigoSituacao === "Q"
      );
      if (paidDebits) {
        this.setState({
          msgSnackbar: Messages.DEBITOS_JA_FORAM_QUITADOS,
        });
        this.props.openSnackComp(true);
      } else if (
        !isValidDate ||
        DataPagamentoDAM < todayDate ||
        DataPagamentoDAM > this.state.maxDateAllowed
      ) {
        this.setState({
          msgSnackbar: Messages.DATA_PAGAMENTO_HOJE_ULTIMO_DIA_MES,
          showPaymentSimulation: false,
        });
        this.props.openSnackComp(true);
      } else {
        api
          .post(
            "/Debitos/PagarCartaoCredito",
            this.props.paymentCreditCardObject
          )
          .then((response) => {
            if (response.data.EhValida) {
              var popupConfig =
                "location=yes,height=900,width=1200,scrollbars=yes,status=yes";
              var URL = response.data.Retorno.UrlPagamento;
              const popup = window.open(URL, "_blank", popupConfig);
              popup.moveTo(1, 2);
              const from = { pathname: "/confirmacao-pagamento-credito" };
              this.props.history.push(from);
            }
            if (!response.data.EhValida) {
              this.setState({
                msgSnackbar: response.data.ResultadoValidacao.Mensagem,
                showPaymentSimulation: false,
                openModal: true,
              });
            }
          })
          .catch((error) => {
            this.setState({
              msgSnackbar: error.data.Exception.Message,
              showPaymentSimulation: false,
              openModal: true,
            });
          });
      }
    } else {
      this.setState({
        msgSnackbar: Messages.SELECIONAR_UM_ITEM,
        openModal: true,
      });
      this.props.openSnackComp(true);
    }
  };

  handleMinimumAmount = () => {
    this.setState({
      msgSnackbar: "Você precisa de no mínimo 1 item para gerar o DAM",
    });

    this.props.openSnackComp(true);
  };

  compareDateWithTodayDate = (date) => {
    const today = new Date();
    const { maxDateAllowed } = this.state;

    return today < date && date <= maxDateAllowed;
  };

  handleDateChange = (date, hasError, errorMsg) => {
    if (!hasError) {
      if (this.compareDateWithTodayDate(date)) {
        this.setState({
          paymentDateValue: date,
          msgSnackbar: Messages.PAGAMENTO_TRIBUTO_FEITO_APOS_DATA_VENCIMENTO,
          titleMessage: "Alteração da data de pagamento",
          openModal: true,
        });
      } else {
        this.setState({
          paymentDateValue: date,
        });
      }
    } else {
      this.setState({
        paymentDateValue: "",
        msgSnackbar: errorMsg,
      });
      this.props.openSnackComp(true);
    }
  };

  closeModal = () => {
    this.setState({ openModal: false, loading: false });
  };

  openSimulationComponent = async (value) => {
    this.setState({ loading: true }, () => this.carregarCardPay());
  };

  carregarCardPay = () => {
    if (
      this.props.acquirerSelected === undefined ||
      this.props.acquirerSelected === null
    ) {
      this.setState({
        msgSnackbar: "Selecione uma credenciada para prosseguir.",
        openModal: true,
        loading: false,
      });

      return;
    }

    const data = {
      Ids: this.props.debitsSelectedIDsValue,
      SiglaAdquirente: this.props.acquirerSelected.Sigla,
      DataPagamento: this.props.paymentDateValue,
    };

    postSimulationCardPayment(data).then((response) => {
      if (response.Retorno !== null) {
        this.setState({
          showPaymentSimulation: true,
          showAcquirerSelection: false,
          simulationData: response.Retorno,
          showTextGuide: false,
          loading: false,
        });
      } else {
        this.setState({
          msgSnackbar: response.ResultadoValidacao.Mensagem,
          openModal: true,
          loading: false,
        });
      }
    });
  };

  render() {
    const { classes } = this.props;

    const user = jwtDecode(JSON.parse(getToken()).access_token);

    return (
      <div>
        {this.state.openModal && this.state.msgSnackbar !== null && (
          <ModalMessage
            userMessage={this.state.msgSnackbar}
            titleMessage={this.state.titleMessage}
            setUserMessageHomeRead={this.closeModal}
            getUserMessageHomeChecked={() => {}}
            modalUserStatusAPI={true}
          />
        )}
        <br />
        <div className={classes.containerPayMethods}>
          <div className={classes.buttonBackDiv}>
            <div>
              <ButtonBack link={"/debitos-selecionados"} />
            </div>
            {this.state.showTextGuide ? (
              <div style={{ display: "flex", marginLeft: "31%" }}>
                <Typography variant="h4" component="h3" color="textSecondary">
                  Selecione uma das opções ao lado para efetuar o pagamento
                </Typography>
              </div>
            ) : null}
          </div>
          <div className={classes.container}>
            <div className={classes.sideMenu}>
              <div
                className={classes.inputsItem}
                onClick={this.handleGenerateDAM}
              >
                <ButtonTypeName
                  className={classes.buttonItem}
                  typeButton={1}
                  icon={classes.svgIcon}
                  sizeIcon={50}
                />
              </div>
              <div
                className={classes.inputsItem}
                onClick={this.newHandleOnlinePayment}
              >
                <ButtonTypeName
                  className={classes.buttonItem}
                  typeButton={2}
                  icon={classes.svgIcon}
                  sizeIcon={50}
                />
              </div>
              {user?.permission.includes("UC007") && (
                <div
                  className={classes.inputsItem}
                  onClick={this.handleAcquirerSelection}
                >
                  <ButtonTypeName
                    className={classes.buttonItem}
                    typeButton={15}
                    icon={classes.svgIcon}
                    sizeIcon={50}
                  />
                </div>
              )}
            </div>
            <div className={classes.contentSelected}>
              {this.state.loading ? (
                <LoadingDefault typeLoading={"card"} />
              ) : (
                <>
                  {this.state.showGenerateDam ? (
                    <PaymentDAM props={this.props} />
                  ) : null}
                  {this.state.showPaymentOnline ? (
                    <div>
                      <PaymentBank
                        setClick={(click) => (this.clickChild = click)}
                        {...this.props}
                      />
                      <div
                        onClick={() => this.clickChild()}
                        style={{ marginRight: "5%", marginTop: "4%" }}
                      >
                        <ButtonTypeName typeButton={16} />
                      </div>
                    </div>
                  ) : null}
                  {this.state.showAcquirerSelection && (
                    <div>
                      <AcquirerSelection
                        loading={this.state.loading}
                        acquirers={this.props}
                      />
                      <div
                        onClick={this.openSimulationComponent}
                        style={{ marginRight: "5%", marginTop: "5%" }}
                      >
                        <ButtonTypeName typeButton={16} />
                      </div>
                    </div>
                  )}
                </>
              )}
              <PaymentSimulation
                open={this.state.showPaymentSimulation}
                payMethod={this.handleCreditCardPayment}
                controllerPayment={(e) =>
                  this.setState({
                    showPaymentSimulation: e,
                  })
                }
                simulationData={this.state.simulationData}
                acquirerSelected={this.state.acquirerSelected}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  valueAmountValue: store.cardDebitState.valueAmountValue,
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
  debitsSelectedIDsValue: store.cardDebitState.debitsSelectedIDsValue,
  openBankInfos: store.cardDebitState.openBankInfos,
  acquirersActives: store.cardDebitState.acquirersActives,
  paymentCreditCardObject: store.cardDebitState.paymentCreditCardObject,
  acquirerSelected: store.cardDebitState.acquirerSelected,
  paymentDateValue: store.cardDebitState.paymentDateValue,
  bankSelectedOnlinePayment: store.cardDebitState.bankSelectedOnlinePayment,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      debitsSelectedComp,
      debitsSelectedIDsComp,
      valueAmountComp,
      openSnackComp,
      setOpenBankInfos,
      setAcquirersActives,
      setBankSelectedOnlinePayment,
    },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(PaymentMethods)
);
